import { render, staticRenderFns } from "./SyncActHistory.vue?vue&type=template&id=4b0d671a&"
import script from "./SyncActHistory.vue?vue&type=script&lang=js&"
export * from "./SyncActHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports